import { IconProps } from "./types";

const OpenEye = ({...props}: IconProps) => {
    return (
        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" {...props}>
            <path
                d="M17.7151 6.86579C18.1101 7.38246 18.1101 8.07996 17.7151 8.59579C16.4709 10.22 13.4859 13.5641 10.0009 13.5641C6.5159 13.5641 3.5309 10.22 2.28674 8.59579C2.09456 8.3484 1.99023 8.04406 1.99023 7.73079C1.99023 7.41753 2.09456 7.11318 2.28674 6.86579C3.5309 5.24163 6.5159 1.89746 10.0009 1.89746C13.4859 1.89746 16.4709 5.24163 17.7151 6.86579V6.86579Z"
                stroke="#100069"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 10.2305C11.3807 10.2305 12.5 9.11118 12.5 7.73047C12.5 6.34976 11.3807 5.23047 10 5.23047C8.61929 5.23047 7.5 6.34976 7.5 7.73047C7.5 9.11118 8.61929 10.2305 10 10.2305Z"
                stroke="#100069"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default OpenEye;
